import { render, staticRenderFns } from "./share-results-modal.vue?vue&type=template&id=af6ad604&scoped=true&"
import script from "./share-results-modal.vue?vue&type=script&lang=ts&"
export * from "./share-results-modal.vue?vue&type=script&lang=ts&"
import style0 from "./share-results-modal.vue?vue&type=style&index=0&id=af6ad604&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af6ad604",
  null
  
)

export default component.exports